module.exports={
	"Scope": "ProjectTagType-List",
	"CoreEntity": "ProjectTagType",
	"TitleTemplate": "Project Tag Types",
	"Descriptors":
	{
		"TagType":
		{
			"Name": "Tag Type",
			"Hash": "PTTListTagType",
			"PictDashboard": {}
		},
		"Name":
		{
			"Name": "Display Name",
			"Hash": "PTTListName",
			"PictDashboard": {}
		},
		"Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "PTTListOrdinal",
			"PictDashboard": {}
		},
		"IDProject":
		{
			"Name": "Project ID",
			"Hash": "PTTListIDProject",
			"PictDashboard": {}
		}
	}
}
